import { useEffect } from 'react';
import { AppState, APP_STATES } from '../lib/global';
import clientSettings from '../lib/client_settings';

const INTERVAL_OK = 60_000; // 60s quando tutto è normale
const INTERVAL_WARN = 10_000; // 10s quando siamo in manutenzione/down

export default function useHealthPolling() {
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;
    let cancelled = false;
    let restorationTimer: ReturnType<typeof setTimeout> | null = null;

    const scheduleNext = () => {
      const current = AppState.getValue();
      const isOk = current === APP_STATES.normal || current === APP_STATES.restoration;
      // eslint-disable-next-line no-use-before-define
      timer = setTimeout(check, isOk ? INTERVAL_OK : INTERVAL_WARN);
    };

    const check = async () => {
      try {
        const res = await fetch(
          clientSettings.public.gpexeGraphUrl.replace('/ui/v2/', '/ping/'),
          { cache: 'no-store' },
        );

        if (cancelled) return;

        if (res.ok) {
          const current = AppState.getValue();

          if (current === APP_STATES.maintenance || current === APP_STATES.down) {
            // Cancella un eventuale restoration timer già in corso
            if (restorationTimer) {
              clearTimeout(restorationTimer);
              restorationTimer = null;
            }
            AppState.setValue(APP_STATES.restoration);
            console.log('Health status: restoration');
            restorationTimer = setTimeout(() => {
              console.log('Health status: normal ', cancelled);
              if (!cancelled) {
                console.log('Health status: normal');
                AppState.setValue(APP_STATES.normal);
                restorationTimer = null;
              }
            }, 5_000);
          }
          // Se siamo già in restoration, non fare nulla:
          // aspetta che il restorationTimer completi da solo
        } else if (res.status === 503) {
          // Se arriva un 503 durante restoration, annulla il timer e torna in maintenance
          if (restorationTimer) {
            clearTimeout(restorationTimer);
            restorationTimer = null;
            console.log('Health status: maintenance while resuming');
          }

          AppState.setValue(APP_STATES.maintenance);
        }
      } catch {
        if (cancelled) return;
        if (restorationTimer) {
          clearTimeout(restorationTimer);
          restorationTimer = null;
        }
        AppState.setValue(APP_STATES.down);
      }

      if (!cancelled) scheduleNext();
    };

    check();

    return () => {
      cancelled = true;
      clearTimeout(timer);
      if (restorationTimer) clearTimeout(restorationTimer);
    };
  }, []);
}
